<template>
  <div>
    <mt-header class="header" title="门店列表">
      <header-item slot="left" v-bind:isBack = true v-on:onclick="goBack">
      </header-item>    
    </mt-header> 
    <!--<div class="refreshText"></div>-->
    <div class="discount-body">
      <mt-cell v-for="(item, index) in shopShowList" :title="item.sname" :key="index" :value="item.distext" :label="item.store_address" @click.native="gotoShop(item)" v-show="true" is-link></mt-cell>
      <!--<mt-cell title="标题" value="内容" label="标签" is-link></mt-cell>-->
	  </div>
  </div>
</template>

<script>
import { HeaderItem } from '../../components/common'
import { Header, Cell } from 'mint-ui'
import { mapState, mapMutations } from 'vuex';
import {  homeAddress } from '../../api/home'
Vue.component(Cell.name, Cell);

export default {
  components: {
    //Cell
  },
  data() {
    return {
      shopShowList:''
    };
  },
  computed: {
    ...mapState({
      shoplist:state => state.auth.shoplist,
      shop:state => state.auth.shop,
      stateAddress:state => state.auth.address,
    }),
  },
  created: function() {
    // Get all shop list
      homeAddress(this.stateAddress.location.lng, this.stateAddress.location.lat, 0 ).then(
        response => {
          if (response && response.error_code ==0) {
            if(Array.isArray(response.shoplist) && response.shoplist.length>0){
              this.shopShowList = response.shoplist;
            }
          }
        },
        error => {
        }
      )
  },
  mounted() {         
    // var _element = document.querySelector('.discount-body'),
    //     _refreshText = document.querySelector('.refreshText'),
    //     _startPos = 0,
    //     _transitionHeight = 0;
    //   _element.addEventListener('touchstart', function (e) {
    //     if(dom.scrollTop != 0) return false
    //     _startPos = e.touches[0].pageY;
    //     _element.style.position = 'relative';
    //     _element.style.transition = 'transform 0s';
    //   }, false);

    //   _element.addEventListener('touchmove', function (e) {
    //     if(_element.scrollTop != 0) return false
    //     _transitionHeight = e.touches[0].pageY - _startPos;
    //     if (_transitionHeight > 20 && _transitionHeight < 60) {
    //       _refreshText.innerText = '下拉刷新';
    //       _element.style.transform = 'translateY(' + _transitionHeight + 'px)';
    //       if (_transitionHeight > 55) {
    //         _refreshText.innerText = '释放更新';
    //       }
    //     }
    //   }, false);
    //   _element.addEventListener('touchend', function (e) {
    //     if(_element.scrollTop == 0 & _transitionHeight >20){
    //       _element.style.transition = 'transform 0.5s ease 1s';
    //       _element.style.transform = 'translateY(0px)';
    //       _refreshText.innerText = '更新中...';
    //       setTimeout(()=>{window.location.reload()},300);
    //     }
    //   }, false);
  },
  activated(){
    this.target = document.querySelector('.discount-body');
    this.target.addEventListener('scroll', (event) => {
      if (this.target.scrollTop) {
        this.offsetTop = this.target.scrollTop
      } 
    });
    if(this.offsetTop) this.target.scrollTop = this.offsetTop
  },
  methods: {
    ...mapMutations({
      saveShop:'saveShop',
      clearCategoryItems:'clearCategoryItems'
    }),
    goBack() {
      this.$router.go(-1); 
    },
    gotoShop(shop) {
      this.saveShop(shop)
      this.clearCategoryItems()
      this.$router.push({ name: 'home'});
      window.location.reload()
    },
  }
}
</script>

<style lang="scss" scoped>

.header {
  @include header;
  background-color: #ed8b19;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  border-bottom: 1px solid $lineColor;
}
.discount-body {
  position: absolute;
  top: 44px;
  bottom: 0px;
  overflow-y: auto;
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/page/shop-list/ShopList.vue